require('./dataAssignmentODM.scss');

// @vendors
const React = require('react');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKLink } = require('commonsComponents/OKLink');

class DataAssignmentODM extends React.Component {

    render() {
        return (
            <OKSectionBox className="data-assignment-odm" title={formatText('dataAssignmentODM-dataAssignmentODM_title')}>
                <div className="row">
                    <div className="col-xs-12 content-no-padding dataAssignmentODM-section__description">
                        <FormattedText value="dataAssignmentODM-dataAssignmentODM_description" />
                    </div>
                    <div className="col-xs-12 content-no-padding last-cell">
                        <OKLink modifier="complementary" to="/myprofile/edit/consent">
                            <FormattedText value="dataAssignmentODM-dataAssignmentODM_link" />
                        </OKLink>
                    </div>
                </div>
            </OKSectionBox>
        );
    }
}


export { DataAssignmentODM };